import { Stack, Typography } from "@mui/material";
import HeightInput, { HeightUnit, HeightValuePayload } from "../HeightInput";
import FormInputErrorList from "../FormInputErrorList";
import { useTranslation } from "react-i18next";
import { convertLength } from "../../../../utils";
import DialogWithTrigger from "../DialogWithTrigger";

interface Props {
  onChange: (data: any) => void;
  errors?: Array<string>;
  data?: HeightValuePayload;
}

export default function QuestionTypeHeight({ onChange, data, errors }: Props) {
  const { t } = useTranslation();

  function isValid(valuePayload: HeightValuePayload) {
    return valuePayload.value && valuePayload.unit ? true : false;
  }

  function normaliseInputValue(valuePayload: HeightValuePayload) {
    if (valuePayload.unit === HeightUnit.M) {
      return {
        value: convertLength(
          HeightUnit.M,
          HeightUnit.CM,
          Number(valuePayload.value)
        ).toString(),
        unit: HeightUnit.CM,
      };
    }
    return valuePayload;
  }

  function onHeightInputChange(valuePayload: HeightValuePayload) {
    onChange({
      data: normaliseInputValue(valuePayload),
      isValid: isValid(valuePayload),
    });
  }

  return (
    <Stack spacing={4} justifyContent="space-between">
      <FormInputErrorList errors={errors || []} />
      <Typography variant="h3">{t("QuestionTypeHeight.title")}</Typography>
      <HeightInput data={data} onChange={onHeightInputChange} />
      <DialogWithTrigger
        title={t("WhyAreWeAskingYouThisModal.title")}
        description={t("QuestionTypeHeight.modalContent")}
      />
    </Stack>
  );
}
